<template>
  <div></div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { RawTimeToTime } from './time'

  export default {
    name: '',
    components: {

    },
    // 定义属性
    data () {
      return {
        timeList: [{
          name: '最近1小时',
          value: '1'
        },
        {
          name: '最近3小时',
          value: '1'
        },
        {
          name: '最近6小时',
          value: '1'
        },
        {
          name: '最近12小时',
          value: '1'
        },
        {
          name: '最近24小时',
          value: '1'
        },
        {
          name: '最近2天',
          value: '1'
        },
        {
          name: '最近7天',
          value: '1'
        },
        {
          name: '最近30天',
          value: '1'
        },
        {
          name: '最近90天',
          value: '1'
        },
        {
          name: '最近6个月',
          value: '1'
        },
        {
          name: '最近6个月',
          value: '1'
        },
        {
          name: '最近1年',
          value: '1'
        },
        {
          name: '最近2年',
          value: '1'
        },
        {
          name: '昨天',
          value: '1'
        },
        {
          name: '前天',
          value: '1'
        },
        {
          name: '上周的这一天',
          value: '1'
        },
        {
          name: '上周',
          value: '1'
        },
        {
          name: '上个月',
          value: '1'
        },
        {
          name: '前一年',
          value: '1'
        },
        {
          name: '今天',
          value: '1'
        },
        {
          name: '今天截至目前',
          value: '1'
        },
        {
          name: '这周',
          value: '1'
        },
        {
          name: '本周截至目前',
          value: '1'
        },
        {
          name: '本月',
          value: '1'
        },
        {
          name: '本月截至目前',
          value: '1'
        },
        {
          name: '今年',
          value: '1'
        },
        {
          name: '今年截至目前',
          value: '1'
        }]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      console.info('=======================')
      const formatter = 'YYYY-MM-DD HH:mm:ss'
      console.info('now-1y/y from', RawTimeToTime('now-1y/y', { end: 'from', format: formatter }))
      console.info('now-1y/y to', RawTimeToTime('now-1y/y', { end: 'to', format: formatter }))
      console.info('now-6m', RawTimeToTime('now-6M', { end: 'form', format: formatter }))
      console.info('now', RawTimeToTime('now', { end: 'now', format: formatter }))
      console.info('now/y from', RawTimeToTime('now/y', { end: 'from', format: formatter }))

      console.info('now/y to', RawTimeToTime('now/y', { end: 'to', format: formatter }))
      console.info('now/M to', RawTimeToTime('now/M', { end: 'to', format: formatter }))
      console.info('now/M from', RawTimeToTime('now/M', { end: 'from', format: formatter }))
      console.info('最近12小时 now-1h/h from', RawTimeToTime('now-12h', { end: 'from', format: formatter }))
      console.info('最近12小时 now-1h/h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近一周 now-1w from', RawTimeToTime('now-1w', { end: 'from', format: formatter }))
      console.info('最近一周 now-1w to', RawTimeToTime('now/w', { end: 'to', format: formatter }))
      console.info('最近一小时 now-1h from', RawTimeToTime('now-1h', { end: 'from', format: formatter }))
      console.info('最近一小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近3小时 now-1h from', RawTimeToTime('now-3h', { end: 'from', format: formatter }))
      console.info('最近3小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近6小时 now-6h from', RawTimeToTime('now-6h', { end: 'from', format: formatter }))
      console.info('最近6小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近12小时 now-1h from', RawTimeToTime('now12h', { end: 'from', format: formatter }))
      console.info('最近12小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近24小时 now-1h from', RawTimeToTime('now-24h', { end: 'from', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近2天  from', RawTimeToTime('now-2d', { end: 'from', format: formatter }))
      console.info('最近2天  to', RawTimeToTime('now/d', { end: 'to', format: formatter }))
      console.info('最近7天  from', RawTimeToTime('now-7d', { end: 'from', format: formatter }))
      console.info('最近7天  to', RawTimeToTime('now/d', { end: 'to', format: formatter }))
      console.info('最近30天  from', RawTimeToTime('now-30d', { end: 'from', format: formatter }))
      console.info('最近30天  to', RawTimeToTime('now/d', { end: 'to', format: formatter }))
      console.info('最近90天  from', RawTimeToTime('now-90d', { end: 'from', format: formatter }))
      console.info('最近90天  to', RawTimeToTime('now/d', { end: 'to', format: formatter }))
      console.info('最近6个月  from', RawTimeToTime('now-6M', { end: 'from', format: formatter }))
      console.info('最近6个月  to', RawTimeToTime('now/M', { end: 'to', format: formatter }))
      console.info('最近6个月  from', RawTimeToTime('now-6M', { end: 'from', format: formatter }))
      console.info('最近1年  to', RawTimeToTime('now-1y/y', { end: 'to', format: formatter }))
      console.info('最近1年  from', RawTimeToTime('now/y', { end: 'from', format: formatter }))
      console.info('最近2年  from', RawTimeToTime('now-2y/y', { end: 'to', format: formatter }))
      console.info('最近2年  to', RawTimeToTime('now/y', { end: 'from', format: formatter }))
      console.info('最近5年  from', RawTimeToTime('now-5y/y', { end: 'to', format: formatter }))
      console.info('最近5年  to', RawTimeToTime('now/y', { end: 'from', format: formatter }))
      console.info('昨天  from', RawTimeToTime('now-1d/d', { end: 'from', format: formatter }))
      console.info('昨天  to', RawTimeToTime('now-1d/d', { end: 'to', format: formatter }))
      console.info('前天  from', RawTimeToTime('now-2d/d', { end: 'from', format: formatter }))

      console.info('前天  to', RawTimeToTime('now-2d/d', { end: 'to', format: formatter }))

      console.info('上周的这一天', RawTimeToTime('now-7d', { end: 'from', format: formatter }))
      console.info('上周的这一天', RawTimeToTime('now-7d', { end: 'to', format: formatter }))
      console.info('上周', RawTimeToTime('now-1w/w', { end: 'from', format: formatter }))
      console.info('上周', RawTimeToTime('now-1w/w', { end: 'to', format: formatter }))
      console.info('上月', RawTimeToTime('now-1M/M', { end: 'from', format: formatter }))
      console.info('上月', RawTimeToTime('now-1M/M', { end: 'to', format: formatter }))
      console.info('上年', RawTimeToTime('now-1y/y', { end: 'from', format: formatter }))
      console.info('上年', RawTimeToTime('now-1y/y', { end: 'to', format: formatter }))
      console.info('今天', RawTimeToTime('now-1d/d', { end: 'from', format: formatter }))
      console.info('今天', RawTimeToTime('now/d', { end: 'to', format: formatter }))

      console.info('最近24小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近24小时 now-1h from', RawTimeToTime('now-24h', { end: 'from', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近24小时 now-1h from', RawTimeToTime('now-24h', { end: 'from', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('now/h', { end: 'to', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('Last 1 hour', { end: 'to', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('Last 3 hours', { end: 'from', format: formatter }))
      console.info('最近24小时 now-1h to', RawTimeToTime('Last 3 hours', { end: 'to', format: formatter }))

      //  console.info(RawTimeToTime('now/y', { end: 'to', format: formatter })
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
